import { render, staticRenderFns } from "./search-result.vue?vue&type=template&id=f1f3f532&"
import script from "./search-result.vue?vue&type=script&lang=js&"
export * from "./search-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports